import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.AddUserButton', {
    addUser: 'Add user',
    addNewUser: 'Add a new user',
    description: 'Type in the email address of the user you want to add',
    emailPlaceholder: 'user@email.com',
});
